import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ShippingRate } from '../../shipping/ShippingRate'

export interface IGetOrderShippingRates extends IAction<ShippingRate[], GetOrderShippingRatesArgs> {}

@InputType()
export class GetOrderShippingRatesArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string
}
